import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import testimonials from "../assets/images/testimonials.png";
import stars from "../assets/images/stars.svg";
import Appstorelogo from "../assets/images/Appstorelogo.svg";
import Appstorelogo1 from "../assets/images/Appstorelogo1.svg";
import "slick-carousel/slick/slick-theme.css";
import "./TestimonialSection.css";

const TestimonialSection = () => {
  const items = [
    {
      id: 1,
      description:
        "I recently tried the new app and was impressed! The personalized recommendations helped me find content I loved, and it ran smoothly with no issues. I highly recommend it for a great experience!",
      headingOne: "Sophie Anderson",
      headingTwo: "San Francisco, CA",
    },
    {
      id: 2,
      description:
        "I recently tried the new app and was impressed! The personalized recommendations helped me find content I loved, and it ran smoothly with no issues. I highly recommend it for a great experience!",
      headingOne: "Sophie Anderson",
      headingTwo: "San Francisco, CA",
    },
    {
      id: 3,
      description:
        "I recently tried the new app and was impressed! The personalized recommendations helped me find content I loved, and it ran smoothly with no issues. I highly recommend it for a great experience!",
      headingOne: "Sophie Anderson",
      headingTwo: "San Francisco, CA",
    },
  ];

  const settings = {
    // centerMode: true,
    // centerPadding: "30%",
    infinite: true,
    slidesToShow: 3,
    speed: 500,
    focusOnSelect: true,
    arrows: false,
    dots: false,
    responsive: [
      // {
      //   breakpoint: 1800,
      //   settings: {
      //     centerPadding: "30%",
      //     slidesToShow: 1,
      //   },
      // },
      {
        breakpoint: 1400,
        settings: {
          // centerPadding: "15%",
          centerMode: false,
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          // centerPadding: "10%",
          centerMode: false,
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          // centerPadding: "5%",
          centerMode: false,
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          // centerPadding: "0%",
          centerMode: false,
          slidesToShow: 1,
        },
      },
    ],
  };
  return (

    <div className="testimonials">
      {/* <img src={testimonials} className="bg-img d-none d-xl-block" /> */}
      <div className="main-div d-flex flex-column justify-content-lg-between container py-5 ">
        <div className="d-flex flex-column justify-content-center text-white mt-lg-5">
          <div className="text-center">
            <h4 className="font-face-PlusJakartaSans-Bold">Testimonials</h4>
            <h1 className="font-face-PlusJakartaSans-Regular">Why people love RealtyBase?</h1>
          </div>
          <div class="row mb-5 p-0">
            <div class="row slider-div p-0">
              <div class="col-lg-12 p-0 col-md-12">
                <Slider {...settings} >
                  {items.map((x, index) => {
                    return (
                      <>
                        <div className="px-2" key={index}>

                          <div className="testimonials-card m-0">
                            <div className="d-flex gap-1 py-3">
                              <div >
                                <img src={stars} style={{ width: "25px" }} />
                              </div>
                              <div >
                                <img src={stars} style={{ width: "25px" }} />
                              </div>
                              <div >
                                <img src={stars} style={{ width: "25px" }} />
                              </div>
                              <div >
                                <img src={stars} style={{ width: "25px" }} />
                              </div>
                              <div >
                                <img src={stars} style={{ width: "25px" }} />
                              </div>
                            </div>
                            <p className="font-face-PlusJakartaSans-Bold text-black pb-3 p-one">
                              {x.description}
                            </p>
                            <p className="font-face-PlusJakartaSans-Regular text-black p-0 m-0">
                              {x.headingOne}
                            </p>
                            <p className="font-face-PlusJakartaSans-Regular text-black p-0 m-0">
                              <i>{x.headingTwo}</i>
                            </p>
                          </div>
                        </div>

                      </>
                    );
                  })}
                </Slider>
              </div>
            </div>
          </div>
        </div>

        <div className="d-flex flex-column align-items-center h-one gap-3 text-white justify-content-center mb-lg-5">
          <h1 className="font-face-PlusJakartaSans-Regular  ">Download Now!</h1>
          <div className="d-flex flex-column flex-lg-row gap-1">


            <div>  <a
              href="https://apps.apple.com/us/app/realtybase/id1581598890"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={Appstorelogo} className="applogo" /></a>
            </div>
            <div>
              <a
                href="https://play.google.com/store/apps/details?id=com.laytra.realestate&hl=en"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={Appstorelogo1} className="applogo" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>


  );
};

export default TestimonialSection;
